// src/hooks/useLeaderboard.ts
import { useState, useEffect } from 'react';
import { getLeaderboard } from '@/lib/firestore';
import { UserStats } from '@/types';

export const useLeaderboard = () => {
  const [leaderboard, setLeaderboard] = useState<UserStats[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      setLoading(true);
      const data = await getLeaderboard(50);
      setLeaderboard(data);
    } catch (error) {
      console.error('Error fetching leaderboard:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return { leaderboard, loading, refresh };
};

